import { RequiredTranslationsTemplate } from '.'

const it: RequiredTranslationsTemplate = {
  meta: {
    localeName: 'Italiano',
  },
  home: {
    title: 'RICHIAMO PRODOTTO ROCKRIDER XC 500 S',
    description:
      'La ringraziamo per la fiducia mostrata verso di noi acquistando una MTB ROCKRIDER XC 500 S. Abbiamo individuato un potenziale problema alla forcella in alcuni casi. La invitiamo quindi a inserire le ultime 6 cifre del numero di serie della Sua MTB Rockrider XC 500 S per scoprire se è interessata da questa campagna di richiamo.',
    form: {
      title: 'La preghiamo di fornire le seguenti informazioni:',
      fields: {
        serialNumber: 'N° di serie:',
        serialNumberFamily: 'N° série (début)',
        firstName: 'Nome',
        lastName: 'Cognome',
        email: 'E-mail',
        phone: 'Tel.',
        country: 'Nazione',
        submit: 'Conferma',
        choose: 'Scegliere...',
      },
      errors: {
        requiredField: 'Questo campo è obbligatorio',
        unknownSerialNumber: 'Numero di serie sconosciuto',
        provide6Numbers: 'Si prega di notare che sono richieste 6 cifre',
      },
      confirmations: {
        good: {
          title: 'La bicicletta non è interessata',
          p1: 'La informiamo che la Sua bici non è interessata da questo richiamo, quindi può continuare a usarla in tutta sicurezza.',
          p2: 'Ci scusiamo per il disagio.',
          p3: 'Sportivamente,',
          p4: 'Le squadre Decathlon',
        },
        defective: {
          title: 'La bicicletta è interessata',
          p1: 'Le chiediamo pertanto di non usarla più e di rivolgersi al laboratorio del negozio Decathlon più vicino, che provvederà a sostituire la forcella.',
          p2: 'La informiamo che la sostituzione potrebbe richiedere qualche giorno. Faremo del nostro meglio per ridurre i tempi necessari. Le consigliamo di consultare direttamente il laboratorio del suo negozio Decathlon abituale per una stima più precisa.',
          p3: 'Per trovare il laboratorio Decathlon più vicino, consulti la pagina:',
          decathlonLocatorLink: 'https://www.decathlon.it/store-locator',
          p4: 'In allegato trova il Suo ordine di riparazione da presentare al nostro tecnico:',
          p5: 'Per saperne di più, La invitiamo a contattare il nostro Servizio Clienti è sempre a sua disposizione sul sito decathlon.it  oppure telefonanedo al numero 039 9007550 (numero a tariffazione ordinaria, il costo varia in funzione del suo piano tariffario)',
        },
      },
    },
    findTheSerialNumber: {
      title: 'Dove trovo il numero di serie?',
      description: 'Il numero di serie si trova sulla forcella',
    },
  },
}

export default it
